<template>
	<div class="top">
		<div class="buttons">
			<share></share>
			<subscribe></subscribe>
		</div>
		<feedback></feedback>
	</div>
</template>

<script>
import subscribe from "./subscribe.vue";
import feedback from "./feedback.vue";
import share from "./share.vue";

export default {
	components: {feedback, share, subscribe}
};
</script>

<style lang="scss" scoped>
.top {
	position: absolute;
	top: 0.5em;
	right: 0.5em;
	z-index: 1;
	text-align: right;

	.buttons {
		display: flex;
	}
}
</style>
